export default __webpack_public_path__ + "static/media/TUNE_DESERT_120X278_01_265.a5b92f07.jpg";